import type { SharedDatabaseView, SharedDbCredentials, SharedDbHostInput } from '@mcpanel/core';
import { rawRequest } from './client';

const db = (name: string) => `/shared-database/databases/${encodeURIComponent(name)}`;

/** 共有データベース（MariaDB・Redis の専用 VM）。変更はオーナーだけ */
export const sharedDbApi = {
  view: () => rawRequest<SharedDatabaseView>('GET', '/shared-database'),
  createHost: (input: Partial<SharedDbHostInput> & { node: string }) =>
    rawRequest<SharedDatabaseView>('POST', '/shared-database/host', input),
  removeFailedHost: () => rawRequest<SharedDatabaseView>('DELETE', '/shared-database/host'),
  backup: () => rawRequest<SharedDatabaseView>('POST', '/shared-database/backup'),
  setDatabase: (name: string, servers: string[]) => rawRequest<SharedDatabaseView>('PUT', db(name), { servers }),
  deleteDatabase: (name: string) => rawRequest<SharedDatabaseView>('DELETE', db(name)),
  credentials: (name: string) => rawRequest<SharedDbCredentials>('GET', `${db(name)}/credentials`),
};
